


















































import { Component, Vue, Prop } from 'vue-property-decorator'
import { OperationItemType } from '../../types/type'
@Component({
  name: 'ConciseCard'
})
export default class ConciseCard extends Vue {
  @Prop({ default: false }) public showTitle: false
  @Prop({ default: '' }) public icon: string
  @Prop({ default: '列表展示' }) public title: string
  @Prop({ default: '105px' }) public titleWidth: string
  @Prop({ default: () => [] })
  public tableHeaderOperationList: OperationItemType[]
  public whoUploadForItem: OperationItemType | null = null

  operationForButton (item: OperationItemType) {
    // 注意：传空对象是为了和列表的操作项传惨保持一致：
    this.$emit('operationForButton', item, {})
  }

  // 导入验证：
  beforeUpload (file: any) {
    let _that: any = this
    let testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
    const extension = testmsg === 'xls'
    const extension2 = testmsg === 'xlsx'
    if (!extension && !extension2) {
      _that.$message({
        message: '上传文件只能是 xls、xlsx格式!',
        type: 'warning'
      })
    }
    return extension || extension2
  }

  mySelfUpload (param: File) {
    this.$emit('operationForButton', this.whoUploadForItem, {}, param)
  }

  operationForUploadInner (item) {
    this.whoUploadForItem = item
  }
}
